var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "activation-container d-flex flex-column justify-space-around"
    },
    [
      _c("div", { staticClass: "d-flex justify-center" }, [
        _c(
          "div",
          [
            _c("div", { staticClass: "va-title" }, [
              _vm._v(_vm._s(_vm.$t("roomWizard.newRoom")))
            ]),
            _c("room-wizard", {
              staticClass: "border-a rounded",
              staticStyle: { width: "70vw" }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }